import { Button } from "@material-ui/core";
import React from "react";
import Right from "../img/right_Triangle.png";

const LongButton = ({ title, img, buttonStyle, imgStyle, setTab }) => (
  <Button className={buttonStyle} onClick={setTab}>
    <img src={img} alt={title} className={imgStyle} />
    {title}
    <img src={Right} alt={title} style={{ marginLeft: "5px" }} />
  </Button>
);
export default LongButton;
